import { get } from "lodash";

export const withDocumentsCompletion = (additionalInfo, isCompleted) => {
  const current = additionalInfo || {};
  if (isCompleted) {
    return {
      ...current,
      isDocumentsCompleted: true,
      documentsCompletedAt:
        get(current, "documentsCompletedAt") || new Date().toISOString(),
    };
  }
  return {
    ...current,
    isDocumentsCompleted: false,
    documentsCompletedAt: null,
    completeDocsReminderSentAt: null,
  };
};
